import type { ClosedOrdersQuery } from 'shared-models/browser';
import type { PastReceiptsFilters } from './past-receipts.types';

// Summary: Build the bounded closed-orders query from page + filters, omitting empty values.
export function buildClosedOrdersQuery(
  page: number,
  pageSize: number,
  filters: PastReceiptsFilters,
): Partial<ClosedOrdersQuery> {
  const query: Partial<ClosedOrdersQuery> = { page, pageSize };
  if (filters.dateFrom) query.dateFrom = filters.dateFrom;
  if (filters.dateTo) query.dateTo = filters.dateTo;
  if (filters.search.trim()) query.search = filters.search.trim();
  if (filters.customer.trim()) query.customer = filters.customer.trim();
  if (filters.sessionId != null) query.sessionId = filters.sessionId;
  return query;
}

// Summary: Format an ISO timestamp as a short he-IL date+time for the receipt row.
export function formatClosedAt(iso: string): string {
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return '';
  return new Intl.DateTimeFormat('he-IL', {
    day: '2-digit',
    month: '2-digit',
    year: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
  }).format(date);
}
